/**
 * itemFx.ts — one shared switch for the item effects on the cars (M145).
 *
 * "Calm" = the Reduced Motion setting or Low quality. The effects that carry
 * INFORMATION (the magnet's field, the shield bubble) stay on screen but stop
 * racing about; the purely decorative ones (boost wind streaks, light trails)
 * are skipped. Game.applySettings is the only writer.
 */
let calm = false;

export function setItemFxCalm(on: boolean): void {
  calm = on;
}

export function itemFxCalm(): boolean {
  return calm;
}
